import { render, staticRenderFns } from "./ChangeInitiatorDialog.vue?vue&type=template&id=0f47d768"
import script from "./ChangeInitiatorDialog.vue?vue&type=script&lang=js"
export * from "./ChangeInitiatorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports